module.exports = __webpack_public_path__ + "img/20191029164809360截图20191029155714101.2ff56fde.jpg";